import type { TextColor } from '../../types';

export type CampaignCardColors =
    | 'White'
    | 'Dark Grey'
    | 'Dark Grey w/ Red'
    | 'Dark Grey with Red Header'
    | 'Dark Grey with Red Preheader'
    | 'Dark Grey with Red Header and Preheader'
    | 'Dark Grey with Red Header and Subheader'
    | 'Dark Grey with Red Subheader'
    | 'White with Red Header'
    | 'Red';

export type CampaignText = 'textColor' | 'headingColor' | 'preheaderColor' | 'subheaderColor';

export const colorMap: Record<CampaignCardColors, Record<CampaignText, TextColor>> = {
    White: {
        textColor: 'White',
        headingColor: 'White',
        preheaderColor: 'White',
        subheaderColor: 'White',
    },
    'Dark Grey': {
        textColor: 'Dark Grey',
        headingColor: 'Dark Grey',
        preheaderColor: 'Dark Grey',
        subheaderColor: 'Dark Grey',
    },
    Red: {
        textColor: 'Red',
        headingColor: 'Red',
        preheaderColor: 'Red',
        subheaderColor: 'Red',
    },
    'Dark Grey with Red Header': {
        textColor: 'Dark Grey',
        preheaderColor: 'Dark Grey',
        subheaderColor: 'Dark Grey',
        headingColor: 'Red',
    },
    'Dark Grey with Red Preheader': {
        preheaderColor: 'Red',
        textColor: 'Dark Grey',
        subheaderColor: 'Dark Grey',
        headingColor: 'Dark Grey',
    },
    'Dark Grey with Red Header and Preheader': {
        textColor: 'Dark Grey',
        subheaderColor: 'Dark Grey',
        preheaderColor: 'Red',
        headingColor: 'Red',
    },
    'Dark Grey with Red Subheader': {
        textColor: 'Dark Grey',
        headingColor: 'Dark Grey',
        preheaderColor: 'Dark Grey',
        subheaderColor: 'Red',
    },
    'Dark Grey with Red Header and Subheader': {
        textColor: 'Dark Grey',
        preheaderColor: 'Dark Grey',
        subheaderColor: 'Red',
        headingColor: 'Red',
    },
    'Dark Grey w/ Red': {
        textColor: 'Dark Grey',
        preheaderColor: 'Red',
        headingColor: 'Red',
        subheaderColor: 'Red',
    },
    'White with Red Header': {
        preheaderColor: 'White',
        textColor: 'White',
        headingColor: 'Red',
        subheaderColor: 'White',
    },
};
